import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

// Do not extend dayjs/plugin/timezone. When it is loaded, the MUI X v6 dayjs adapter builds typed
// picker dates in timezone mode, and a date typed into a month other than the current one then
// gives the wrong instant (its local wall time is sent as UTC).
dayjs.extend(utc)
